import axios, { AxiosResponse } from 'axios';
import { searchUrl } from 'findem-helpers';

const EnrichedProfileAPI = {
  fetchProfiles: async (payload: { joid: string; prids: string[] }): Promise<AxiosResponse<any>> => {
    return axios.post(`${searchUrl}/pub/api/profile`, {
      type: 'Profiles',
      prids: payload.prids,
      joid: payload.joid,
      detail: 'true',
      bust_cache: true
    }, { withCredentials: true });
  },

  fetchProfilesSummaryByPost: async (payload: { prids: string[]; joid: string }): Promise<AxiosResponse<any>> => {
    return axios.post(`${searchUrl}/pub/api/copilot-profile-summary`, {
      prids: payload.prids,
      joid: payload.joid
    }, { withCredentials: true });
  },
};

export default EnrichedProfileAPI;
